import { AController } from "@eagerlogic/react-mvc";
import { ApiException } from "rpc/rpc";
import { AuthRpc } from "rpc/auth/AuthRpc";
import { ForgotPasswordModel } from "../model/ForgotPasswordModel";

export class ForgotPasswordController extends AController<ForgotPasswordModel> {

    protected createInitialModel(): ForgotPasswordModel {
        return new ForgotPasswordModel();
    }

    public onSubmitClicked(email: string) {
        this.model.email = email;
        this.model.error = null;
        this.render(this.model);

        AuthRpc.requestPasswordReset(email).then(() => {
            this.model.submitted = true;
            this.render(this.model);
        }).catch((ex: ApiException) => {
            this.model.error = ex.message != null ? ex.message : "Something went wrong. Please try again.";
            this.render(this.model);
        });
    }

}
